export default __webpack_public_path__ + "static/media/loginimage.4d111d77.png";